module.exports = __webpack_public_path__ + "static/1st-tpm-1-6a84f310c5c762bb38b307d0400ecb07.jpg";